import { lsStorageService, lsStorageServiceConstants, lsFilters } from 'ls-vue-common';
import _ from 'lodash';
import moment from 'moment-timezone';
// eslint-disable-next-line import/no-cycle
import { apolloClient } from '@/vue-apollo';
// eslint-disable-next-line import/no-cycle
import router from '@/router';
import { isMonthlyMowingDisabled } from './market';

function logout() {
    lsStorageService.clear(_.values(lsStorageServiceConstants));
    apolloClient.clearStore().then(() => {
        router.replace(
            {
                name: 'guest',
            },
            _.noop
        );
    });
}

// TODO: add tests
function goToParentView({ replace = false } = {}) {
    router[replace ? 'replace' : 'push']({
        name: router.currentRoute.matched[router.currentRoute.matched.length - 2].name,
    });
}

function parseTimestamp({ timestamp }) {
    return `${moment
        .utc(timestamp)
        .tz('America/Chicago')
        .format('MMM D, YYYY h:mm A')} (CT)`;
}

function dateRange({ start, end, format = 'monthDateYear' }) {
    const startsAt = lsFilters.date({
        date: start,
        format,
    });

    const endsAt =
        end && start !== end
            ? ` – ${lsFilters.date({
                  date: end,
                  format,
              })}`
            : '';

    return `${startsAt}${endsAt}`;
}

function isMowing({ schedule }) {
    return _.get(schedule, 'service.str_id') === 'mowing';
}

function isRecurringMowing({ schedule }) {
    return _.get(schedule, 'service.str_id') === 'mowing' && schedule.cycle > 0;
}

function pricingSubLabel({ price, trust_fee, tax }) {
    return `(${lsFilters.currency({
        amount: price,
    })} + ${lsFilters.currency({
        amount: trust_fee,
        emptyDisplay: '$0.00',
    })} T&S Fee + ${lsFilters.currency({
        amount: tax,
        emptyDisplay: '$0.00',
    })} Tax)`;
}

function getLocationsString({ locations }) {
    const locationsOptions = {
        front_yard: 'Front-yard',
        back_yard: 'Backyard',
        left_yard: 'Left side',
        right_yard: 'Right side',
        other_yard: 'Other',
        full_yard: 'Full yard',
    };

    return _.reduce(
        locations,
        (result, value, key) => {
            if (value && _.endsWith(key, '_yard')) {
                result.push(locationsOptions[key]);
            }
            return result;
        },
        []
    ).join(', ');
}

function getUnselectableDaysOfWeekFromDayOfWeekAvailability(day_of_week_availability) {
    const unselectableDaysOfWeek = [];
    if (!day_of_week_availability.monday) {
        unselectableDaysOfWeek.push(1);
    }
    if (!day_of_week_availability.tuesday) {
        unselectableDaysOfWeek.push(2);
    }
    if (!day_of_week_availability.wednesday) {
        unselectableDaysOfWeek.push(3);
    }
    if (!day_of_week_availability.thursday) {
        unselectableDaysOfWeek.push(4);
    }
    if (!day_of_week_availability.friday) {
        unselectableDaysOfWeek.push(5);
    }
    if (!day_of_week_availability.saturday) {
        unselectableDaysOfWeek.push(6);
    }
    if (!day_of_week_availability.sunday) {
        unselectableDaysOfWeek.push(0);
    }
    return unselectableDaysOfWeek;
}

// eslint-disable-next-line import/prefer-default-export
export const lsHelpers = {
    logout,
    goToParentView,
    parseTimestamp,
    dateRange,
    isMowing,
    isRecurringMowing,
    pricingSubLabel,
    getLocationsString,
    getUnselectableDaysOfWeekFromDayOfWeekAvailability,
    isMonthlyMowingDisabled,
};
